import { createSDK } from "@agroyaar/sdk";
import { authMiddleware } from "@new-services/middleware/auth";

const baseURL = process.env.REACT_APP_AUTOMATION_BASE_URL ?? "";
export const client = createSDK(
  {
    baseURL: baseURL,
  },
  [authMiddleware]
);
